import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { redirectToPage } from 'srcReact/helpers/history'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

const CommonHeader = ({ activeItem, setActiveItem, selectedWorkplace, isMobileMainPage }) => {
  const { t } = useTranslation()

  const {
    common: { isNative, isDesktop },
    workplaceSettings: { workplace_members }
  } = useSelector((state) => state)

  const handleBackButton = () => {
    if (activeItem === t('workplaceSettings.title')) {
      redirectToBack(isNative)
    }
    setActiveItem(t('workplaceSettings.title'))
  }

  const getItemCount = (item) => {
    if (item === t('global.members')) {
      return `(${workplace_members?.members_stats?.total})`
    }
  }

  return (
    <div className={`${styles.commonHeaderWrapper}`}>
      <div
        className={`${styles.commonHeader} ${styles[selectedWorkplace?.color]} ${
          !isMobileMainPage && styles.innerHeader
        } `}>
        <h2 className={styles.workplaceName}>{selectedWorkplace?.name}</h2>
        {selectedWorkplace?.role?.includes('workplace-manager') && (
          <Button
            text={t('nav.dashboard')}
            iconPosition='end'
            customStyle={styles.button}
            icon2={<Icon name='arrow-right' size='large24' />}
            handleClick={() => redirectToPage(`/0/dashboard/workplace/${selectedWorkplace?.id}`, isNative)}
          />
        )}
      </div>
      {/* {!isDesktop && !isMobileMainPage && (
        <div className={styles.commonMobileHeader}>
          <BackNavigation className={styles.back} customHandleBack={handleBackButton} />
          <h1 className={styles.heading}>
            {activeItem} {getItemCount(activeItem)}
          </h1>
        </div>
      )} */}
    </div>
  )
}

export default CommonHeader
